import { Locale, type LocalizedString } from "../../../schema/Locale.js";

export const cognitoNameToTextMapping: Record<string, LocalizedString> = {
	NotAuthorizedException: {
		[Locale.cs]: "Přístup odepřen.",
		[Locale.en]: "Access denied.",
	},
	CodeMismatchException: {
		[Locale.cs]: "Zadaný kód není správný.",
		[Locale.en]: "Entered code is not correct",
	},
	UserNotFoundException: {
		[Locale.cs]: "Uživatel nenalezen.",
		[Locale.en]: "User not found.",
	},
	InvalidPasswordException: {
		[Locale.cs]: "Zadané heslo není správné.",
		[Locale.en]: "Invalid password",
	},
	LimitExceededException: {
		[Locale.cs]: "Byl dosažen limit pokusů. Zkuste to prosím později.",
		[Locale.en]: "You have exceeded the maximum amount of tries. Please try again later.",
	},
	ExpiredCodeException: {
		[Locale.cs]: "Potvrzovací kód vypršel. Zažádejte si o nový.",
		[Locale.en]: "Your confirmation code has expired. Request a new one.",
	},
	UsernameExistsException: {
		[Locale.cs]: "Uživatel s tímto emailem již existuje.",
		[Locale.en]: "A user with this email already exists.",
	},
};

export function getExpectedCognitoError(error: unknown, locale: Locale, fallback?: string): string | undefined {
	return error instanceof Error ? cognitoNameToTextMapping[error.name]?.[locale] : fallback;
}
